// @ts-nocheck
import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { verificationCodeSentKey } from '../../helpers/app'
import { urls } from '../../routing'
import {
  AuthenticationService,
  LiteralsService
} from '../../services'
import {
  confirmVerificationCodeFailedAction,
  setIsSigningUpAction,
  setNotificationAction,
  signUpFailedAction,
  signUpSuccessfulAction
} from '../actions'
import { ISignUpState, IStoreState } from '../states'
import { SignUpTypeKeys } from '../types'
import { goToAuthScreen } from './auth-navigation'

// Worker Saga
function* fetchSignUpAsync() : any {
  try {
    yield put(setIsSigningUpAction())
    const signUp: ISignUpState = yield select(
      (state: IStoreState) => state.signUp
    )
    yield call(AuthenticationService.signUp, { ...signUp })
    yield* goToAuthScreen(urls.signUpStep1)
    yield put(signUpSuccessfulAction())
    yield put(
      setNotificationAction({
        isError: false,
        label: LiteralsService.get(verificationCodeSentKey, true)
      })
    )
    yield* goToAuthScreen(urls.accountVerificationStep)
  } catch (error: any) {
    const errorKey = error?.name || error?.code || error?.underlyingError?.name
    yield put(confirmVerificationCodeFailedAction())
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.getOrDefault(errorKey, 'serverError', true)
      })
    )
    yield put(signUpFailedAction(error))
  }
}

// Watcher Saga:
function* watchFetchSignUpAsync() {
  yield takeLatest(SignUpTypeKeys.SIGN_UP, fetchSignUpAsync)
}

// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([
    watchFetchSignUpAsync()
  ])
}
